function getTypography() {
    const fontWeightLight = 300;
    const fontWeightRegular = 400;
    const fontWeightMedium = 500;
    const fontWeightBold = 600;
    return {
        fontFamily: '"Inter", sans-serif',
        fontWeightLight,
        fontWeightRegular,
        fontWeightMedium,
        fontWeightBold,
        allVariants: {
            fontVariantLigatures: 'none'
        },
        h1: {
            fontSize: '1.5rem',
            fontWeight: fontWeightBold,
            lineHeight: '32px'
        },
        h2: {
            fontSize: '1.25rem',
            fontWeight: fontWeightBold,
            lineHeight: '28px'
        },
        h3: {
            fontSize: '1rem',
            fontWeight: fontWeightBold,
            lineHeight: '24px'
        },
        h4: {
            fontSize: '0.875rem',
            fontWeight: fontWeightBold,
            lineHeight: '22px'
        },
        h5: void 0,
        h6: void 0,
        body1: {
            fontSize: '0.875rem',
            fontWeight: fontWeightRegular,
            lineHeight: '20px'
        },
        body2: {
            fontSize: '0.75rem',
            fontWeight: fontWeightRegular,
            lineHeight: '18px'
        },
        subtitle1: {
            fontSize: '1rem',
            fontWeight: fontWeightRegular,
            lineHeight: '24px',
            letterSpacing: 'normal'
        },
        subtitle2: {
            fontSize: '0.875rem',
            fontWeight: fontWeightMedium,
            lineHeight: '22px',
            letterSpacing: 'normal',
            textTransform: 'uppercase'
        },
        button: {
            fontSize: '0.875rem',
            fontWeight: fontWeightMedium,
            lineHeight: '1.25rem',
            textTransform: 'none',
            letterSpacing: 'normal'
        },
        caption: {
            fontSize: '0.6875rem',
            fontWeight: fontWeightRegular,
            lineHeight: '16px'
        },
        overline: void 0,
        overline1: {
            fontSize: '0.875rem',
            fontWeight: fontWeightRegular,
            lineHeight: '20px',
            letterSpacing: 'normal',
            textTransform: 'uppercase'
        },
        overline2: {
            fontSize: '0.75rem',
            fontWeight: fontWeightRegular,
            lineHeight: '18px',
            letterSpacing: 'normal',
            textTransform: 'uppercase'
        },
        code: {
            fontFamily: 'monospace',
            fontSize: '0.75rem',
            fontWeight: fontWeightRegular,
            lineHeight: '20px'
        }
    };
}
export { getTypography };

//# sourceMappingURL=typography.js.map